import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium', type = 'default', message }) => {
  const sizeClass = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large',
  }[size] || 'spinner-medium';

  return (
    <div className={`loading-container ${sizeClass}`} data-type={type} role="status">
      <div className="loading-spinner-ring" aria-hidden="true" />
      <p className="loading-status">{message || '불러오고 있어요'}</p>
    </div>
  );
};

export default LoadingSpinner;
